//src/utils/Validators.ts
import moment from 'moment';
import * as Yup from 'yup';

const dateRange = Yup.object().shape({
  from: Yup.string().nullable(),
  to: Yup.string().test('toTest', 'Invalid Date', function (value) {
    if (!value) return true;
    // if (!moment(value, 'HH:mm').isValid()) {
    //   return this.createError({ message: 'Invalid Time' });
    // }

    // if (
    //   moment(this.parent.from, 'HH:mm').isSameOrAfter(
    //     moment(this.parent.to, 'HH:mm'),
    //   )
    // ) {
    //   return this.createError({
    //     message: 'to time must be after from time',
    //   });
    // }

    return true;
  }),
});

export const Validators = {
  zipCode: Yup.string()
    .nullable()
    .trim()
    .matches(
      /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5} \d{4}$)|(^$)/,
      'Invalid format',
    ),

  dateRanges: Yup.array(),

  upload: (min: number) =>
    Yup.object()
      .nullable()
      .required('Required')
      .shape({
        files: Yup.array()
          .min(min, 'Required')
          .of(
            Yup.object({
              id: Yup.string().nullable(),
              url: Yup.string().nullable(),
              title: Yup.string().nullable(),
            }),
          ),
      }),
};
